import {auctionAddresss, eggAssetTokenId, adoptionContract, nodeUrl} from '../contract functions/Constants';

export async function getTotalNoOfPands() {
  let count = 0;
  await fetch( nodeUrl +'addresses/data/' + adoptionContract + '/stats_PANDA_quantity').then(res => res.json()).then(
    (result) => {
      // console.log(result);
      if(result.value!=undefined)
        count=result.value;
    }
  )
// console.log(count);
  return count;
}

export async function getAdoptionAmount() {
  let amount=1;
  await fetch( nodeUrl +'addresses/data/' + adoptionContract + '/pandas_amount').then(res => res.json()).then(
    (result) => {
      // console.log(result);
      if(result.value!=undefined){
        let n =result.value;//totalPandasAmount
        let g = 10//discountCoefficient
        let t = 9//typesAmount
        let price = Math.pow((100 + ((n * g) / (10 * t))), 2, 5, 1, 2, Math.DOWN)
        amount=Math.fround(price * 10000);
      } else
        amount=amount * 150000000;
    }
  )
  return amount;
}

export async function getAllAuctions() {
  let auctionList = [];
  await fetch( nodeUrl +'addresses/data/' + auctionAddresss + '?matches=%5Eauction_%5Ba-zA-z0-9%5D%7B1%2C44%7D_status%24').then(res => res.json()).then(
    (result) => {
      // console.log(result);
      result.forEach((item) => {
          auctionList.push(item.key.substr(8, 44));
      });
    }
  )
// console.log(auctionList);
  return auctionList;
}

export async function getAllOpenAuctions() {
  let auctionList = [];
  await fetch( nodeUrl +'addresses/data/' + auctionAddresss + '?matches=%5Eauction_%5Ba-zA-z0-9%5D%7B1%2C44%7D_status%24').then(res => res.json()).then(
    (result) => {
      // console.log(result);
      result.forEach((item) => {
        if (item.value == "open") {
          auctionList.push(item.key.substr(8, 44));
        }
      });
    }
  )
  // console.log(auctionList);
  return auctionList;
}

export async function getAllOpenAuctionsCount() {
  let count = 0;
  await fetch( nodeUrl +'addresses/data/' + auctionAddresss + '?matches=%5Eauction_%5Ba-zA-z0-9%5D%7B1%2C44%7D_status%24').then(res => res.json()).then(
    (result) => {
      // console.log(result);
      result.forEach((item) => {
        if (item.value == "open") {
          count++;
        }
      });
    }
  )
  // console.log(count);
  return count;
}

export async function getAllCloseAuctions() {
  let auctionList = [];
  await fetch( nodeUrl +'addresses/data/' + auctionAddresss + '?matches=%5Eauction_%5Ba-zA-z0-9%5D%7B1%2C44%7D_status%24').then(res => res.json()).then(
    (result) => {
      // console.log(result);
      result.forEach((item) => {
        if (item.value != "open") {
          auctionList.push(item.key.substr(8, 44));
        }
      });
    }
  )
  // console.log(auctionList);
  return auctionList;
}

export async function getAuctionDetails(auctionId) {
  let auctionData = {}
  auctionData['auctionId'] = auctionId;
  auctionData['assetId'] = await getAuctionDetailsByKey(auctionId, '_assetId');
  auctionData['status'] = await getAuctionDetailsByKey(auctionId, '_status');
  auctionData['auctionStartPrice'] = await getAuctionDetailsByKey(auctionId, '_startPrice');
  auctionData['auctionInstantPrice'] = await getAuctionDetailsByKey(auctionId, '_instantPrice');
  auctionData['auctionDescription'] = await getAuctionDetailsByKey(auctionId, '_description');
  auctionData['auctionOwner'] = await getAuctionDetailsByKey(auctionId, '_owner');
  auctionData['auctionStartedAt'] = await getAuctionDetailsByKey(auctionId, '_startedAt');
  auctionData['assetData'] = await getAssetDetails(auctionData.assetId);
  //Bids data
  var bidList = await getAllBids(auctionId);
  auctionData['totalBids'] = bidList.length;
  // console.log(auctionData);
  return auctionData;
}

async function getAuctionDetailsByKey(auctionId, key) {
  let value;
  await fetch( nodeUrl +'addresses/data/' + auctionAddresss + '/auction_' + auctionId + key).then(res => res.json()).then(
    (result) => {
      // console.log(result);
      value = result.value;
    }
  )
  // console.log(value);
  return value;
}

export async function getAllBids(auctionId) {
  let bidList = [];
  await fetch( nodeUrl +'addresses/data/' + auctionAddresss + '?matches=%5Eaddress_%5Ba-zA-z0-9%5D%7B1%2C44%7D_auction_' + auctionId + '_bid_.%2A').then(res => res.json()).then(
    (result) => {
      // console.log(result);
      result.forEach((item) => {
        bidList.push(item.key.substr(101));
      });
    }
  )
  // console.log(bidList);
  return bidList;
}

export async function getBidDetails(auctionId, bidId) {
  let bidData = {}
  bidData['auctionId'] = auctionId;
  bidData['bidId'] = bidId;
  bidData['author'] = await getBidDetailsByKey(auctionId, bidId, '_author');
  bidData['amount'] = await getBidDetailsByKey(auctionId, bidId, '_amount');
  bidData['status'] = await getBidDetailsByKey(auctionId, bidId, '_status');
  // console.log(bidData);
  return bidData;
}

async function getBidDetailsByKey(auctionId, bidId, key) {
  let value;
  await fetch( nodeUrl +'addresses/data/' + auctionAddresss + '/auction_' + auctionId + '_bid_' + bidId + key).then(res => res.json()).then(
    (result) => {
    // console.log(result);
      value = result.value;
    }
  )
  // console.log(value);
  return value;
}

export async function getAssetDetails(assetId) {
  let assetData;
  await fetch( nodeUrl +'assets/details/' + assetId + '?full=false').then(res => res.json()).then(
    (result) => {
      // console.log(result);
      assetData = result;
    }
  )
  // console.log(assetData);
  return assetData;
}

export async function getAccountWaveBalance(walletAddress) {
  let walletBalance;
  await fetch( nodeUrl +'addresses/balance/' + walletAddress).then(res => res.json()).then(
    (result) => {
      // console.log(result);
      walletBalance = result.balance;
    }
  )
  // console.log(walletBalance);
  return walletBalance / 10 ** 8; //decimal
}

export async function getAccountAssetBalance(walletAddress) {
  let walletBalance;
  await fetch( nodeUrl +'assets/balance/' + walletAddress + '/' + eggAssetTokenId).then(res => res.json()).then(
    (result) => {
      // console.log(result);
      walletBalance = result.balance;
    }
  )
  // console.log(walletBalance);
  return walletBalance / 10 ** 8; //decimal
}

export async function getAllNFTs(walletAddress, limit) {
  let NFTList;
  await fetch( nodeUrl +'assets/nft/' + walletAddress + '/limit/' + limit).then(res => res.json()).then(
    (result) => {
      // console.log(result);
      NFTList = result;
    }
  )
  // console.log(NFTList);
  return NFTList;
}

export async function getAssetBalance(walletAddress, assetId) {
  let balance;
  await fetch( nodeUrl +'assets/balance/' + walletAddress + '/' + assetId).then(res => res.json()).then(
    (result) => {
    // console.log(result);
      balance = result.balance;
    }
  )
// console.log(balance);
  return balance;
}

export async function getMyAuctions(walletAddress) {
  let NFTList = [];
  await fetch( nodeUrl +'addresses/data/' + auctionAddresss + '?matches=%5Eaddress_' + walletAddress + '_auction_%5Ba-zA-z0-9%5D%7B1%2C44%7D_lockedNFT%24').then(res => res.json()).then(
    (result) => {
      // console.log(result);
      result.forEach((item) => {
        NFTList.push(item.value);
        NFTList.push(item.key.substr(52, 44));
      });
    }
  )
  // console.log(NFTList);
  return NFTList;
}


export async function getMyBidsAuctions(walletAddress) {
  let bidAuctionsList = [];
  await fetch( nodeUrl +'addresses/data/' + auctionAddresss + '?matches=address_' + walletAddress + '_auction_.%2A').then(res => res.json()).then(
    (result) => {
      // console.log(result);
      result.forEach((item) => {
        bidAuctionsList.push(item.key.substr(52,44));
      });
    }
  )
  // console.log(bidAuctionsList);
  return bidAuctionsList;
}

export async function getMyAuctionDetails(auctionId) {
  let auctionData = {}
  auctionData['auctionId'] = auctionId;
  auctionData['assetId'] = await getAuctionDetailsByKey(auctionId, '_assetId');
  auctionData['assetData'] = await getAssetDetails(auctionData.assetId);
  //Bids data
  var bidList = await getAllBids(auctionId);
  auctionData['totalBids'] = bidList.length;
  // console.log(auctionData);
  return auctionData;
}

/************************************************************
 *             Convert Token values
************************************************************/

export function convertNormaltoTokenAmount(normalValue) {
  if(normalValue==undefined)
    return "0";
  return normalValue* 10** 8; // decimal 8
}

//.substr(0,4) for change decimals
export function convertTokentoNormalAmount(tokenValue) {
  if(tokenValue==undefined)
    return "0.00000000";
  return (tokenValue/ 10**8).toFixed(8); // decimal 8
}